/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/012-droplet': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13.51 7.393C12.483 4.527 10.305 1.953 8 0 5.695 1.953 3.518 4.527 2.49 7.393c-.635 1.772-.698 3.696.197 5.397C3.716 14.745 5.791 16 8 16s4.284-1.255 5.313-3.21c.895-1.701.832-3.624.197-5.397zm-1.967 4.466A4.045 4.045 0 018 14a4.03 4.03 0 01-2.377-.791c.207.027.416.041.627.041a5.056 5.056 0 004.428-2.676c.701-1.333.64-2.716.373-3.818.227.44.42.878.576 1.311.353.985.625 2.443-.084 3.791z"/>'
  }
})
